import React from 'react';
import { AccountMenuItem } from '../account-menu-item/AccountMenuItem';
import styles from './account-menu.scss';
import { AccountLink } from '../links';

interface AccountMenuProps {
  isOpen: boolean;
  accountLinks: AccountLink[];
}

export const AccountMenu = ({ isOpen, accountLinks }: AccountMenuProps) =>
  isOpen ? (
    <div className={styles.overlayContainer} data-testid="account-menu">
      <div className={styles.overlay} data-test="overlay">
        <div className={styles.overlayHeader}>
          <h2>My account</h2>
        </div>
        <div className={styles.overlayBody}>
          {accountLinks.map(accountLink => (
            <AccountMenuItem
              key={accountLink.name}
              name={accountLink.name}
              href={accountLink.url}
              showNotification={accountLink.showNotification}
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;

AccountMenu.displayName = 'AccountMenu';
